import React, { useRef , useState }  from "react";
import { createRoot } from "react-dom/client"; // <-- IMPORT arriba
import PlayerDropboxNew from './PlayerDropboxNew'
import { useTranslation } from 'react-i18next';

import vehicleNewWeb from "../images/tutovehicle01.png";
import vehicleNew from "../images/vehicleNew.png";
import spawnNewWeb from "../images/spawnNewWeb.png";
import spawnNew from "../images/spawnNew.png";
import tpsNewWeb from "../images/tpsNewWeb.png";
import tpsNew from "../images/tpsNew.png";
import spacialNewWeb from "../images/spatialNewWeb.png";
import spacialNew from "../images/spatialNew.png";


function GamesNew(){
const { t, i18n } = useTranslation();
const containerRef = useRef(null);
const containerImplementationRef = useRef(null);

const handleClickInside = () => {
    if (containerRef.current) {
      const root = createRoot(containerRef.current); // renderiza el video
      root.render(<div className = "video-main-container" ><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/gqiptf1kgbt3mox2zxi6b/InsideCredits.mp4?rlkey=gjkvq9hurs9l54c0qtcsq6888&st=tazc1to7&dl=0"/></div>);
     
      containerRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
    }
   
  };
   
const handleClickLords = () => {
    if (containerRef.current) {
      const root = createRoot(containerRef.current); // renderiza el video
      root.render(<div className = "video-main-container"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/8ggwggzgczflehd7m0564/Aftertouch-Audio-Sound-Design-Contest_Cecilia-Garcia.m4v?rlkey=qzski437fumjb2ixlcwd2p7ng&st=n2zizuwh&dl=0"/></div>);
   
      containerRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
   
    }
   
  };

const handleClickOver = () => {
    if (containerRef.current) {
      const root = createRoot(containerRef.current); // renderiza el video
      root.render(<div className = "video-main-container"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/0h2n36bvykhz4y580mn1j/Overwatch-2-Sojourn.mp4?rlkey=dksw1s4z7dbncbr9dh4whlyd1&st=vs0uzu30&dl=0"/></div>);
  
        containerRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
  
    }
   
  };

  const handleClickNfs = () => {
    if (containerRef.current) {
      const root = createRoot(containerRef.current); // renderiza el video
      root.render(<div className = "video-main-container"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/dts6xixicazlihkeak82a/NeedForSpeed.mp4?rlkey=in8hgau7voemigk6vx2tf7re1&st=2uh1aurf&dl=0"/></div>);
  
      containerRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
  
    }
   
  };

  const handleClickImpTps = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/vtgm1bwyoh3b2hde12uiw/TPS-DEMO-LOCU.mp4?rlkey=817pgv0302klwqbyo1d6uto85&st=zvkz5x4v&dl=0"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
  
    }
   
  };


  const handleClickImpSpacial = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/kbi22aksdoeh81fuao78o/Spacial-Audio-Implementation.mp4?rlkey=rtrm716edfune06s4dedqz4xk&st=ocmrq8s6&dl=0"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
  
    }
   
  };

    const handleClickImpVehicle = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/m982t0fh625zw0eyvbvps/VehicleUE5Final.mp4?rlkey=aqvs8lvzy3cb6p6hn26x5w6e3&st=u47857b3&dl=0"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
  
    }
   
  };

   const handleClickImpSpawnComp = () => {
    if (containerImplementationRef.current) {
      const root = createRoot(containerImplementationRef.current); // renderiza el video
      root.render(<div className = "video-main-container"><PlayerDropboxNew source="https://www.dropbox.com/scl/fi/lkjpi3mvi9o53fnqo1qfo/EmittterCompAndMSS.mp4?rlkey=i7o7sq64w3rf5q8ukxcr2wbt4&st=d3y0qjw4&dl=0"/></div>);
  
      containerImplementationRef.current.scrollIntoView({
      behavior: "smooth", // desplazamiento suave
      block: "center",    // lo ubica en el centro de la pantalla
    });
  
    }
   
  };

    return(
      <div className="overlay-content overlay-games " >

                    <div className="sectionText">
                      <h2 style={{  fontFamily: 'LeagueGothic' }} className="page-section-heading text-center text-uppercase  title mb-0 ">{t('GamesSubt1')}</h2> 
                    </div>

                    <div  ref={containerRef}></div>
                    
                    <div className = "video-main-container game-design-container" >
                      

                        <div class="row g-3 pt-4">
                          <div style={{ position: "relative", display: "inline-block" }} className = "videos-container col-12 col-md-6 col-lg-6" >
                            <div className="ratio ratio-16x9 bg-dark text-white">
                              <img  class="click-to-video"
                                  src="./images/overNew.png"
                                  alt="Click para reproducir"
                                  style={{ cursor: "pointer", width: "100%" , height: "100%" }}
                                  onClick={handleClickOver}        
                              />
                           </div>
                                                         {/* Flecha/play */}
                            <div className="hover-arrow">
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t('GamesDesignTitle3')}</p> 
                                <p className="font-face-OpenSans text-group-subtitle">{t('GamesDesignSubt3')}</p> 
                              </div>    
                            </div>
                          </div>

                          <div style={{ position: "relative", display: "inline-block" }} className = "videos-container col-12 col-md-6 col-lg-6" >
                            <div className="ratio ratio-16x9 bg-dark text-white">
                              <img  class="click-to-video"
                                  src="./images/nfsNew.png"
                                  alt="Click para reproducir"
                                  style={{ cursor: "pointer", width: "100%" , height: "100%" }}
                                  onClick={handleClickNfs}        
                              />
                            </div>
                                                          {/* Flecha/play */}
                            <div className="hover-arrow">
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t('GamesDesignTitle4')}</p> 
                                <p className="font-face-OpenSans text-group-subtitle">{t('GamesDesignSubt4')}</p> 
                              </div>                                
                            </div>
                          </div>
                      </div>


<div class="row g-3 pt-4">
                            <div style={{ position: "relative", display: "inline-block" }} className = "videos-container col-12 col-md-6 col-lg-6" >
                            <div className="ratio ratio-16x9 bg-dark text-white" >
                              <img  class="click-to-video"
                                  src="./images/insideNew.png"
                                  alt="Click para reproducir"
                                  style={{ cursor: "pointer", width: "100%" , height: "100%" }}
                                  onClick={handleClickInside}        
                              />                                   
                           </div>
                              {/* Flecha/play */}
                            <div className="hover-arrow"  >
                              <i className="fas fa-play fa-3x "></i>
                            
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t('GamesDesignTitle1')}</p> 
                                <p className="font-face-OpenSans text-group-subtitle">{t('GamesDesignSubt1')}</p> 
                              </div>    
                           
                            </div>
                  
                          </div> 

                          <div style={{ position: "relative", display: "inline-block" }} className = "videos-container col-12 col-md-6 col-lg-6" >
                            <div className="ratio ratio-16x9 bg-dark text-white">
                              <img  class="click-to-video"
                                  src="./images/lordsNew.png"
                                  alt="Click para reproducir"
                                  style={{ cursor: "pointer", width: "100%" , height: "100%" }}
                                  onClick={handleClickLords}        
                              />
                            </div>
                                                          {/* Flecha/play */}
                            <div className="hover-arrow">
                              <i className="fas fa-play fa-3x"></i>
                      

                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t('GamesDesignTitle2')}</p> 
                                <p className="font-face-OpenSans text-group-subtitle">{t('GamesDesignSubt2')}</p> 
                              </div>   

                            </div>
                          </div>
                      </div>

                    </div>


                    <div className="sectionText mt-5">
                      <h2 style={{  fontFamily: 'LeagueGothic' }} className="page-section-heading text-center text-uppercase  title mb-0 ">{t('GamesSubt2')}</h2> 
                    </div>


                    <div  ref={containerImplementationRef}></div>
                    
                    <div className = "video-main-container" >
                      <div class="row g-3 pt-4">

                          {/* Vehicle*/}
                          <div
                            className="videos-container col-12 col-md-6 col-lg-6"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${vehicleNewWeb})`,
                                  "--imageMobile": `url(${vehicleNew})`,
                              
                              }}>
                                
                            <div className="ratio ratio-16x9 bg-dark text-white">
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpVehicle}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow">
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("GamesBreakTitle1")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("GamesBreakSubt1")}</p>
                              </div>
                            </div>
                          </div>

                          
                        {/* spawn - dropbox cigfernandez2*/}
                          <div
                            className="videos-container col-12 col-md-6 col-lg-6"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${spawnNewWeb})`,
                                  "--imageMobile": `url(${spawnNew})`,
                              
                              }}>
                                
                            <div className="ratio ratio-16x9 bg-dark text-white">
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpSpawnComp}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow">
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("GamesBreakTitle2")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("GamesBreakSubt2")}</p>
                              </div>
                            </div>
                          </div>
                          
                          {/* TPS - dropbox cigfernandez2*/}
                          <div
                            className="videos-container col-12 col-md-6 col-lg-6"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${tpsNewWeb})`,
                                  "--imageMobile": `url(${tpsNew})`,
                              
                              }}>
                                
                            <div className="ratio ratio-16x9 bg-dark text-white">
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpTps}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow">
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t('GamesBreakTitle3')}</p> 
                                <p className="font-face-OpenSans text-group-subtitle">{t('GamesBreakSubt3')}</p> 
                              </div>
                            </div>
                          </div>

                          
                           {/* SPACIAL - dropbox cigfernandez2*/}

                          <div
                            className="videos-container col-12 col-md-6 col-lg-6"
                            style={{ 
                              position: "relative", 
                              display: "inline-block",
                                  "--imageWeb": `url(${spacialNewWeb})`,
                                  "--imageMobile": `url(${spacialNew})`,
                              
                              }}>
                                
                            <div className="ratio ratio-16x9 bg-dark text-white">
                              <div
                                className="click-to-video-adaptive"
                                onClick={handleClickImpSpacial}
                                role="button"
                                aria-label="Click para reproducir"
                              ></div>
                            </div>

                            <div className="hover-arrow">
                              <i className="fas fa-play fa-3x"></i>
                              <div className="text-group">
                                <p className="font-face-LeagueGothic text-group-title">{t("GamesBreakTitle4")}</p>
                                <p className="font-face-OpenSans text-group-subtitle">{t("GamesBreakSubt4")}</p>x 
                              </div>
                            </div>
                          </div>



                          
                      </div> 
                    </div>
       </div>
    )
}
export default GamesNew